import React from "react";
import { View } from "react-native";
import { CommunityScreen } from "./CommunityScreen.js";

/** Community feed embedded in the main tab pager. */
export function CommunityTabPanel() {
  return (
    <View style={{ flex: 1 }}>
      <CommunityScreen embedded />
    </View>
  );
}
